import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-billiard-ball",
  "use": "icon-si-glyph-billiard-ball-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-billiard-ball\" id=\"icon-si-glyph-billiard-ball\"><title>917</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\"><path d=\"M8.01,0.057 C3.627,0.057 0.071,3.611 0.071,7.997 C0.071,12.382 3.628,15.937 8.01,15.937 C12.395,15.937 15.95,12.381 15.95,7.997 C15.95,3.61 12.395,0.057 8.01,0.057 L8.01,0.057 Z M7.01,12.114 C4.206,12.114 1.934,9.831 1.934,7.015 C1.934,4.201 4.206,1.917 7.01,1.917 C9.815,1.917 12.088,4.2 12.088,7.015 C12.088,9.831 9.814,12.114 7.01,12.114 L7.01,12.114 Z\" class=\"si-glyph-fill\" /><rect x=\"7\" y=\"4\" width=\"0.938\" height=\"5.938\" class=\"si-glyph-fill\" /><rect x=\"6\" y=\"4\" width=\"1.969\" height=\"0.938\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-billiard-ball.svg
// module id = BdX0
// module chunks = 62